import {
    HttpResponse,
    FilterModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class FiltersDataService implements CrudService<FilterModel, FilterModel> {

    getBasicAll(query: CrudDataQuery<FilterModel>): Promise<CrudEnumerableResponse<FilterModel>> {
        throw new Error("Method not implemented.");
    }

    clone(item: FilterModel, params?: RequestParams): Promise<CrudResponse<FilterModel>> {
        throw new Error("Method not implemented.");
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }

    getAll(query: CrudDataQuery<FilterModel>): Promise<CrudEnumerableResponse<FilterModel>> {
        return ApiService.api.getFilterBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<FilterModel>> {
        return ApiService.api.getFilterById(id, params);
    }

    create(item: FilterModel, params?: RequestParams): Promise<CrudResponse<FilterModel>> {
        return ApiService.api.insertFilter(item, params);
    }

    update(item: FilterModel, params?: RequestParams): Promise<FilterModel> {
        return ApiService.api.updateFilter(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<FilterModel> {
        return ApiService.api.patchFilter(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<FilterModel>): Promise<CrudEnumerableResponse<FilterModel>> {
        return ApiService.api.deleteFilters(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel): Promise<AggregationResponse> {
        return ApiService.api.aggregationFilter(query).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<FilterModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    print(id: string, params?: RequestParams): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

}
